import React, { useState, useEffect } from 'react';
import XtLoading from '@/components/xtLoading';
import cs from './index.module.scss';

const FullPageLoading: React.FC = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);

    return (): void => {
      setShow(false);
    };
  }, []);

  return <div className={cs.container}>{show && <XtLoading />}</div>;
};

export default FullPageLoading;
